module.exports = __webpack_public_path__ + "8bc52d30e8923b5bc1b270896aa721df.png";